import { useMutation } from '@tanstack/react-query';

import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useBookingId } from 'reservations/booking/providers/BookingProvider';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import type { BookingFormSchema } from 'reservations/form/components/Form';
import { cleanGuestsFormData } from 'reservations/form/helpers/cleanBookingFormData';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useUpdateGuestsMutation = () => {
  const bookingId = useBookingId();
  const { close } = useModal();
  return useMutation<
    BookingMutationResponse,
    RequestError,
    Record<string, any>
  >({
    mutationKey: ['UPDATE_GUESTS'],
    mutationFn: async formData => {
      const endpoint = getBookingEndpoint(bookingId, 'guests');
      const cleanedFormData = cleanGuestsFormData(
        formData as BookingFormSchema
      );
      const response = await restClient.put(endpoint, {
        data: Object.fromEntries(cleanedFormData)
      });

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        console.error('useUpdateGuestsMutation: ', err);
        throw err;
      }
    },
    onSuccess: _data => {
      close();
    }
  });
};
